import { Empty, Pagination, Link, Text } from "ui-components";

import { JobsData } from "@/src/hooks/api/generated";

interface IJobsTableProps {
  data: JobsData;
  page: number;
  pageSize?: number;
  setPage: (value: number) => void;
}

export function JobsDataTable({
  data,
  page,
  pageSize = 10,
  setPage,
}: IJobsTableProps): JSX.Element {
  return (
    <div className="flow-root">
      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <table className="min-w-full divide-y divide-gray-300">
            <thead className="bg-[#D9D9D9] text-center">
              <tr>
                <th scope="col" className="py-5">
                  <Text>Job ID</Text>
                </th>
                <th scope="col" className="py-5">
                  <Text>Job Title</Text>
                </th>
                <th scope="col" className="py-5">
                  <Text>Job Country</Text>
                </th>
                <th scope="col" className="py-5">
                  <Text>Job Views</Text>
                </th>
                <th scope="col" className="py-5">
                  <Text>Clicks on Apply</Text>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 text-center">
              {data.data.length === 0 && (
                <tr>
                  <td colSpan={5} aria-label="no record found.">
                    <Empty text="No data found." />
                  </td>
                </tr>
              )}
              {data.data.map((item) => (
                <tr key={item.id}>
                  <td className="whitespace-nowrap py-4 pl-4 pr-3 font-medium text-gray-900 sm:pl-0">
                    {item.id}
                  </td>
                  <td className="py-5">
                    {item.isActive ? (
                      <Link
                        target="_blank"
                        href={`/jobs/${item.slug}`}
                        className="underline underline-offset-4"
                      >
                        <Text className="break-words whitespace-normal">
                          {item.title}
                        </Text>
                      </Link>
                    ) : (
                      <Text>{item.title}</Text>
                    )}
                  </td>
                  <td className="py-5">
                    <Text>{item.country}</Text>
                  </td>
                  <td className="py-5">
                    <Text>{item.views}</Text>
                  </td>
                  <td className="py-5">
                    <Text>{item.clicks}</Text>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {!!data.total && (
            <div className="mt-5">
              <Pagination
                currentPage={page}
                totalPages={Math.ceil((data?.total ?? 0) / pageSize)}
                totalRecords={data?.total ?? 0}
                onPageChange={(newPageNumber) => {
                  setPage(newPageNumber);
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
